import React, { useContext } from "react";
import _ from "lodash";
import { DrawerHocStorefront } from "../DrawerHoc/DrawerHocStorefront";
import { StorefrontContext } from "../../context/storefrontContext";
import "./Cart.scss";
import { getItemPrice, getShippingPrice, getShipping } from "utils/utils";

export const CartStorefront = (props) => {
  const { cart, addItemToCart, removeItemFromCart, updateItemQuantity } =
    useContext(StorefrontContext);

  const getLineItems = () => {
    if (!cart?.lines?.edges) return [];
    return cart.lines.edges.map((edge) => edge.node);
  };

  const handleAddItem = (variantId) => {
    addItemToCart(variantId, 1);
  };

  const handleRemoveItem = (lineId) => {
    removeItemFromCart(lineId);
  };

  const handleUpdateQuantity = (lineId, currentQuantity, change) => {
    const newQuantity = currentQuantity + change;
    if (newQuantity <= 0) {
      handleRemoveItem(lineId);
    } else {
      updateItemQuantity(lineId, newQuantity);
    }
  };

  const lineItems = getLineItems();

  return (
    <DrawerHocStorefront
      title="Shopping Cart"
      footer={
        <div className="buttonWrapper">
          <a
            className="button"
            href={cart?.checkoutUrl || "#"}
            target="_blank"
            rel="noopener noreferrer"
          >
            Checkout
          </a>
        </div>
      }
    >
      {_.isEmpty(lineItems) ? (
        <div>There are no items in the shopping cart</div>
      ) : (
        lineItems.map((item) => {
          const product = item.merchandise.product;
          const variant = item.merchandise;
          const image = product.images?.edges?.[0]?.node;

          return (
            <div key={item.id} className="cart-wrapper">
              <img
                className="cart-image"
                src={image?.url || ""}
                alt={image?.altText || product.title}
              />
              <ul className="cart-ul-description">
                <li className="item-text">{product.title}</li>
                <li className="item-text">{variant.title}</li>
                <li className="item-text">{item.quantity} item(s)</li>
                <li className="item-text">
                  Individual item cost:
                  <br />${parseFloat(variant.price.amount).toFixed(2)} + Free
                  Shipping/Case
                </li>
              </ul>
              <div className="cart-button-wrapper">
                <button
                  className="button cart-button-mods"
                  onClick={() =>
                    handleUpdateQuantity(item.id, item.quantity, 1)
                  }
                >
                  <span>+</span>
                </button>
                <button
                  className="button cart-button-mods"
                  onClick={() =>
                    handleUpdateQuantity(item.id, item.quantity, -1)
                  }
                >
                  <span>-</span>
                </button>
              </div>
            </div>
          );
        })
      )}
    </DrawerHocStorefront>
  );
};

export default CartStorefront;
